import { render, staticRenderFns } from "./NarratorSlide.vue?vue&type=template&id=33e58621&"
import script from "./NarratorSlide.vue?vue&type=script&lang=js&"
export * from "./NarratorSlide.vue?vue&type=script&lang=js&"
import style0 from "./NarratorSlide.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports